<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="select($event)" (alt)="alt()" (cancel)="cancel()">
  @if (data.text) {
    <p>{{ data.text }}</p>
  }
  <ng-container [formGroup]="formGroup">
    @for (item of data.items; track item; let i = $index) {
      <div>
        <mat-form-field formArrayName="select">
          <mat-label>{{ item.name }}</mat-label>
          <mat-select formControlName="{{ i }}" [placeholder]="item.name" data-test="multiple-select-dialog-item">
            @for (option of data.values; track option) {
              <mat-option [value]="option.value" data-test="multiple-select-dialog-option">
                {{ option.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </ng-container>
  @if (data.items.length === 0) {
    <div>
      {{ data.emptyText }}
    </div>
  }
</agr-form-dialog>
